import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';

import Quagga from '@ericblade/quagga2';
import { CodeReaderBaseComponent } from '@features/code-readers/code-reader-base/code-reader-base.component';

@Component({
  templateUrl: './barcode-reader.component.html',
  styleUrls: ['./barcode-reader.component.css'],
  imports: [CodeReaderBaseComponent],
})
export class BarcodeReaderComponent implements OnDestroy, OnInit {
  @ViewChild('target') target!: ElementRef<HTMLDivElement>;

  private initialized = false;
  private responsePromise?: Promise<string>;
  private rejectPromise?: (reason?: string) => void;

  ngOnInit(): void {
    this.initialized = true;
  }

  async ngOnDestroy() {
    await this.stopBarcodeScanner();
  }

  startBarcodeScanner() {
    this.responsePromise = new Promise<string>(async (resolve, reject) => {
      this.rejectPromise = reject;

      while (!this.initialized) {
        await new Promise((r) => setTimeout(r, 1));
      }

      if (!navigator.mediaDevices || typeof navigator.mediaDevices.getUserMedia !== 'function') {
        console.error('Camera not supported.');
        return;
      }

      await Quagga.init(
        {
          inputStream: {
            type: 'LiveStream',
            target: this.target.nativeElement, // The element to render the webcam stream
            constraints: {
              facingMode: 'environment', // rear camera
            },
          },
          decoder: {
            readers: ['code_39_reader', 'code_39_vin_reader'],
          },
        },
        (err: Error) => {
          if (err) {
            console.error(err);
            reject(err);
            return;
          }

          console.log('Initialization finished. Ready to start');
          Quagga.start();
        },
      );

      Quagga.onDetected((data) => {
        if (!data.codeResult.code) return;
        resolve(data.codeResult.code);
      });
    });

    this.responsePromise.then(
      () => this.cleanup(),
      () => this.cleanup(),
    );

    return this.responsePromise;
  }

  async stopBarcodeScanner() {
    if (this.responsePromise) {
      this.rejectPromise?.('Operation canceled by user');
      await this.cleanup();
    }
  }

  protected async cleanup() {
    await Quagga.stop();
    this.rejectPromise = undefined;
  }
}
